import { sendVersicherungsfallV2 } from "@/api/schadensmeldung";
import AbschlussModal from "@/components/schadensmeldung/AbschlussModal";

export const schadensmeldungNeu = {
    data() {
        return {
            showWelcomeSection: true,
            showSummaryAfterFormChange: false,
            isFormSubmitted: false,
        };
    },
    beforeRouteLeave(to, from, next) {
        if (to.path !== "/aktion") {
            if (
                !this.isFormSubmitted &&
                to.name !== "login" &&
                !this.showWelcomeSection
            ) {
                this.$ionic.alertController
                    .create({
                        header: "Seite verlassen?",
                        message:
                            "Möchtest du die aktuelle Seite wirklich verlassen? Die Formulardaten werden nicht gespeichert.",
                        buttons: [
                            {
                                text: "Nein",
                                role: "cancel",
                                handler: () => {
                                    next(false);
                                },
                            },
                            {
                                text: "Ja",
                                handler: () => {
                                    next();
                                },
                            },
                        ],
                    })
                    .then((a) => a.present());
            } else {
                next();
            }
        }
    },
    computed: {
        hasSchadensmeldungContract() {
            let result = false;
            if (
                this.$store.getters.schadensmeldungen[this.feature] &&
                this.$store.getters.schadensmeldungen[this.feature].length > 0
            ) {
                result = true;
            }
            return result;
        },
        contractDetails() {
            let result = {};
            const polizzenversicherung = this.formData.polizzenversicherung;
            if (this.$store.state.contractsDetails.all[polizzenversicherung]) {
                result = this.$store.state.contractsDetails.all[
                    polizzenversicherung
                ];
            }
            return result;
        },
        welcomeText() {
            let result = "";
            if (this.$store.state.user.details.vorname) {
                result =
                    "Hallo " + this.$store.state.user.details.vorname + ",";
            } else {
                result = "Hallo,";
            }
            return result;
        },
    },
    methods: {
        changeFormData(event) {
            for (let data of event) {
                if (this.formData[data.id] !== undefined) {
                    this.formData[data.id] = data.value;
                }
            }
            this.$refs.page.scrollToTop();
            if (this.showSummaryAfterFormChange) {
                this.formData.formstep = this.stepCount;
                this.showSummaryAfterFormChange = false;
            } else {
                this.formData.formstep++;
            }
        },
        changeStep(event) {
            this.$refs.page.scrollToTop();
            this.formData.formstep = event;
            this.showSummaryAfterFormChange = true;
        },
        stepBack() {
            if (this.formData.formstep > 1) {
                this.showSummaryAfterFormChange = false;
                this.formData.formstep--;
            } else {
                this.$router.go(-1);
            }
        },
        submitForm() {
            this.$ionic.alertController
                .create({
                    header: "Schadensmeldung übermitteln",
                    message:
                        "Möchtest du die Schadensmeldung jetzt an Wüstenrot übermitteln?",
                    buttons: [
                        {
                            text: "Nein",
                            role: "cancel",
                        },
                        {
                            text: "Ja",
                            handler: () => {
                                this.sendVersicherungsfall();
                            },
                        },
                    ],
                })
                .then((a) => a.present());
        },
        sendVersicherungsfall() {
            this.$store.commit("setLoading", true);
            sendVersicherungsfallV2(this.formData).then(() => {
                this.$ionic.modalController
                    .create({
                        component: AbschlussModal,
                        componentProps: {
                            propsData: {
                                formData: this.formData,
                            },
                            parent: this,
                        },
                        backdropDismiss: false,
                    })
                    .then((m) => {
                        //  m.onDidDismiss().then(() => {
                        // this.isFormSubmitted = true;
                        // this.$router.push({
                        //     name: "schadensmeldung-neu",
                        // });
                        //  this.sendVersicherungsfall();
                        //  });
                        m.present();
                    });
                // this.$refs.page.scrollToTop();
                // if (response.data.Status === 200) {
                //     this.isFormSubmitted = true;
                //     let modriveText = "";
                //     if (
                //         this.formData.modrive &&
                //         this.formData.modrive === "Ja" &&
                //         this.formData.modriveVersicherungsart !==
                //             "Nur Haftpflicht"
                //     ) {
                //         modriveText =
                //             " und du wirst umgehend von MO'Drive kontaktiert";
                //     }
                //     this.$ionic.alertController
                //         .create({
                //             header: "Schadensmeldung erfolgreich",
                //             message:
                //                 "Deine Schadensmeldung wurde erfolgreich an Wüstenrot übermittelt" +
                //                 modriveText +
                //                 ".",
                //             buttons: ["Ok"],
                //         })
                //         .then((a) => {
                //             a.onDidDismiss().then(() => {
                //                 this.$router.push({
                //                     name: "schadensmeldung",
                //                 });
                //                 this.$store.commit("setAskForRating", true);
                //             });
                //             a.present();
                //         });
                // }
            });
        },
    },
};
